import { NeighborhoodModel } from '@padspin/firestore-neighborhoods';

export const get_neighborhoods_fn_name = 'get_neighborhoods' as const;
export type GetNeighborhoodsRequestData = { place_ids: string[] };
export type GetNeighborhoodsResponse = Record<string, NeighborhoodModel>;
